import type { ComponentSchema } from '../../../../../schema-types'

/** Khelaghor cart page: steps band, cart lines, totals with the backend's delivery areas. Keys follow lightings-1. */
export const schema: ComponentSchema = {
  type: 'cart',
  label: 'Cart',
  description: 'Cart lines with quantity steppers, delivery area choice, free-delivery progress and checkout.',
  supportedPages: ['cart'],
  variants: [{ id: 'v1', label: 'Lines + totals box' }],
  commonFields: [
    { key: 'pageTitle', label: 'Page title (for screen readers)', type: 'string', default: 'Shopping cart' },
    { key: 'emptyTitle', label: 'Empty cart title', type: 'string', default: 'Your cart is currently empty.' },
    { key: 'emptyMessage', label: 'Empty cart message', type: 'string' },
    { key: 'continueShoppingText', label: 'Continue shopping text', type: 'string', default: 'Continue shopping' },
    { key: 'continueShoppingLink', label: 'Continue shopping link', type: 'string', default: '/shop' },
    { key: 'summaryTitle', label: 'Totals title', type: 'string', default: 'Cart totals' },
    { key: 'subtotalLabel', label: 'Subtotal label', type: 'string', default: 'Subtotal' },
    { key: 'shippingLabel', label: 'Delivery label', type: 'string', default: 'Delivery' },
    { key: 'shippingCalculatedText', label: 'Text when delivery areas are unavailable', type: 'string', default: 'Delivery charge is added at checkout.' },
    { key: 'totalLabel', label: 'Total label', type: 'string', default: 'Total' },
    { key: 'checkoutButtonText', label: 'Checkout button text', type: 'string', default: 'Proceed to checkout' },
    { key: 'checkoutLink', label: 'Checkout link', type: 'string', default: '/checkout' },
  ],
}
